import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import log from "@/lib/log";

const ThemeContext = createContext(null);
// Theme is a non-sensitive UI preference (dark | light) — localStorage is appropriate.
const STORAGE_KEY = "aieco.theme";

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (v === "light" || v === "dark") return v;
    } catch (e) {
      log.warn("[theme] localStorage read failed:", e?.message || e);
    }
    return "dark";
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, theme); } catch (e) {
      log.warn("[theme] localStorage write failed:", e?.message || e);
    }
    document.documentElement.setAttribute("data-theme", theme);
    document.documentElement.classList.toggle("theme-light", theme === "light");
  }, [theme]);

  const value = useMemo(
    () => ({ theme, setTheme, toggle: () => setTheme((t) => (t === "dark" ? "light" : "dark")) }),
    [theme]
  );
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used inside ThemeProvider");
  return ctx;
}
